import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelObjectTenantSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelObjectTenantSettingsEntity
